'use-strict'
import React from "react";
import {
    HasRole,
    HasPermission
  } from 'react-role-permission'
import app from '../../../data/base';
import sessions from '../../sessions/sessionsutils'
import {
    
    Media,
    
  } from "reactstrap";
  import moment from 'moment';


const dashboard = {
    auth: {
        onAuthStateChanged: app.auth.onAuthStateChanged
    },
    methods : {
      callserver : app.methods.callserver,
      loadsessioni : sessions.methods.loadSessioni,
      loadsessionimockup : sessions.methods.loadsessioniMockup
    }
  };
  export default dashboard;